var map = {
	"./bloomberg.svg": [
		981,
		1
	],
	"./dargebotene-hand.svg": [
		982,
		42
	],
	"./facebook.svg": [
		983,
		2
	],
	"./imdb.svg": [
		984,
		3
	],
	"./instagram.svg": [
		985,
		4
	],
	"./linkedin.svg": [
		986,
		5
	],
	"./mapbox.svg": [
		987,
		6
	],
	"./samaritians.svg": [
		988,
		43
	],
	"./skyscanner.svg": [
		989,
		14
	],
	"./telefon-seelsorge-at.svg": [
		990,
		44
	],
	"./telefon-seelsorge-de.svg": [
		991,
		45
	],
	"./tripadvisor.svg": [
		992,
		8
	],
	"./twitter.svg": [
		993,
		9
	],
	"./website.svg": [
		994,
		10
	],
	"./wikipedia.svg": [
		995,
		11
	],
	"./youtube.svg": [
		996,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 864;
module.exports = webpackAsyncContext;